import React, { Component } from "react";
import autoBind from "auto-bind";
import { connect } from "react-redux";

import SubscriberSearchResults from "./subscriber_search_results.jsx";
import SuppressionSearchResults from "./suppression_search_results.jsx";

class ResultSection extends Component {
  constructor(props) {
    super(props);
    autoBind(self);
  }

  render() {
    return this.props.err ? (
      <div className="alert alert-error">{this.props.err}</div>
    ) : (
      <div>
        <SubscriberSearchResults organizationID={this.props.organizationID} />

        <SuppressionSearchResults organizationID={this.props.organizationID} />
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  organizationID: state.organizationID,
  err: state.error,
});

export default connect(mapStateToProps)(ResultSection);
